'use strict';
angular.module('weiboHeadlinesModule', []).controller('weiboHeadlinesCtrl', ['$scope', '$q', '$timeout', '$state', '$stateParams', '$compile', '$element', 'weiboConst', 'messagePublishService', 'trsHttpService', 'beforeonload', 'editingCenterWeiBoService', 'ueditorService', '$validation', 'sensitiveWordCheckService', 'jsonArrayToStringService', 'storageListenerService', 'modalDialog', 'editingCenterService', 'editPictureService', 'editingMediatype',
    function($scope, $q, $timeout, $state, $stateParams, $compile, $element, weiboConst, messagePublishService, trsHttpService, beforeonload, editingCenterWeiBoService, ueditorService, $validation, sensitiveWordCheckService, jsonArrayToStringService, storageListenerService, modalDialog, editingCenterService, editPictureService, editingMediatype) {
        initStatus();
        initData();
        editingCenterWeiBoService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.parentStatus = {
                support: {
                    content: ''
                },
                switch: 'manuscriptInfo',
                topAttachFilePicSize: '300,168',
                wbMetadataId: $stateParams.wbmetadataid === undefined ? 0 : $stateParams.wbmetadataid,
                platform: $stateParams.wbplatform,
                articleid: $stateParams.wbmetadataid === undefined ? 0 : $stateParams.wbmetadataid,
            };
            $scope.parentData = {
                imgSrc: '',
                mediaType: editingMediatype.weibo,
            };
            $scope.element = $element;
            $scope.compile = $compile;
            $scope.editFlag = {
                media: 'weibo', 
                docType: 'news',
            };
        }

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            var defer = $q.defer();
            if (angular.isDefined($stateParams.wbmetadataid)) {
                initEditData().then(function() {
                    beforeonload.beforeonloadAlert($scope);
                    defer.resolve();
                });
            } else {
                initNewData().then(function() {
                    beforeonload.beforeonloadAlert($scope);
                    defer.resolve();
                });
            }
            return defer.promise;
        }

        /**
         * [initEditData description] 编辑稿件时初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initEditData() {
            var defer = $q.defer();
            $scope.parentStatus.isChangeContent = false;
            var params = {
                serviceid: 'wcm61_scmmicrocontent',
                methodname: 'findByIdToJson',
                ObjectId: $stateParams.wbmetadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.list = data;
                $scope.parentData.remarks = data.REMARKS;
                document.title = data.TITLE;
                if (!data.TEXT) {
                    $scope.list.TEXT = '发布了头条文章：《' + $scope.list.TITLE + '》'; 
                }
                $scope.parentData.imgSrc = '/wcm/file/read_image.jsp?FileName=' + data.COVER;
                messagePublishService.publish(`${$scope.parentStatus.mediaName}VersionInit`);
                messagePublishService.publish('hasGetEditInfo', true); // 表示已请求到数据 通知各子组件得到数据后处理数据
                loadDirective();
                defer.resolve();
            });
            editingCenterWeiBoService.lockWeibo($stateParams.wbmetadataid);
            return defer.promise;
        }

        /**
         * [initNewData description] 新建稿件时初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initNewData() {
            var defer = $q.defer();
            $scope.parentStatus.isChangeContent = true;
            $scope.list = angular.extend({
                COVER: '',
                SUMMARY: '',
                CONTENT: '',
                HTMLCONTENT: '',
                DOCTYPEID: '17',
            }, weiboConst.list);
            loadDirective();
            defer.resolve();
            return defer.promise;
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
        // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.wbheadlinesForm.$error) {
                errorArray.push(error);
            }
            $scope.parentStatus.wbheadlinesFormError = $scope.parentStatus.wbheadlinesFormError === undefined ? [] : $scope.parentStatus.wbheadlinesFormError;
            if ($scope.parentStatus.wbheadlinesFormError.length !== errorArray.length) {
            // 长度不相等说明表单errorname发生变化
                $scope.parentStatus.wbheadlinesFormError = errorArray;
            }
            return $scope.parentStatus.wbheadlinesFormError; // 返回
        };

        /**
         * [loadDirective description]动态加载指令
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            if ($stateParams.issave === undefined || $stateParams.issave === '0') {
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function() {
                    var ueditor = '<ueditor versionid="parentData.lastVersionid" edit-flag="editFlag" type="{{\'newmedia\'}}" draft-type="headline" show-cover-btn="{{\'true\'}}" callback="picCallbackData()" infullscreen="parentStatus.infullscreen" list="list" has-content="parentStatus.hasContent" class="newEditor"></ueditor>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    var ue = UE.getEditor('ueditor');
                    $scope.parentStatus.support.content = $scope.list.CONTENT;
                    ue.ready(function() {
                        ue.addListener('keydown', function(type, event) {
                            if (event.keyCode === 13) {
                                $scope.parentStatus.support.content = ue.getContentTxt();
                            }
                        });
                        defer.resolve();
                    });
                    var supportCreation = '<support-creation is-trs-check-menu="{{\'true\'}}" parent-parentStatus="parentStatus" big-face-switch="parentStatus.bigFaceSwitch" has-editor="true" is-news="true" media-type="{{\'2\'}}" is-check-sensitive-words="parentStatus.isCheckSensitiveWords" list="list"></support-creation>';
                    supportCreation = $compile(supportCreation)($scope);
                    $element.find('supportcreation').append(supportCreation);
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        $scope.changeWeiboContent = function() {
            if ($scope.parentStatus.isChangeContent) {
                $scope.list.TEXT = '发布了头条文章：《' + $scope.list.TITLE + '》' ;
                $scope.parentStatus.isChangeContent = false;
            }
        };

        /**
         * [deleteUploaderImg description] 删除封面图
         *
         * @return  {[type]}  [return description]
         */
        $scope.deleteUploaderImg = function() {
            $scope.list.COVER = '';
            $scope.parentData.imgSrc = '';
            $scope.parentData.IMAGEDESC = '';
        };

        $scope.save = function() {
            return $scope.doSave(true);
        };
        
        /**
         * [save description] 保存函数
         *
         * @param   {[type]}  isFinished  [isFinished description] 判断是否是保存操作
         *
         * @return  {[type]}              [return description]
         */
        $scope.doSave = function(isFinished) {
            var defer = $q.defer();
            ueditorService.saveContent($scope.list);
            $scope.wbheadlinesForm.$pending = {};
            $validation.validate($scope.wbheadlinesForm).success(function() {
                messagePublishService.publish('packageParams', true); // 保存时通知各子组件组装参数
                var list = angular.copy($scope.list);
                sensitiveWordCheckService.sensitiveWords($scope).then(function (sensitiveWords) {
                    list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length && sensitiveWords.length > 0 ? 1 : 0;
                    list.serviceid = 'wcm61_scmmicrocontent';
                    list.methodname = 'saveMicroBlogToJson';
                    list.ACCOUNTIDS = $state.params.wbchannelid;
                    list.OBJECTID = $scope.parentStatus.wbMetadataId;
                    list = jsonArrayToStringService.jsonArrayToString(list);
                    $scope.wbheadlinesForm.$setPristine();
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWeiboRootUrl(), list, 'post', true).then(function(data) {
                        $state.params.wbmetadataid = JSON.parse(data.METADATAID);
                        $scope.parentStatus.wbMetadataId = JSON.parse(data.METADATAID);
                        $scope.list.METADATAID = data.METADATAID;
                        beforeonload.refresh($scope);
                        if (isFinished) {
                            storageListenerService.addListenerToWeibo('save');
                            $state.transitionTo($state.current, $state.params, {
                                reload: false,
                            });
                            $timeout(function() {
                                modalDialog.saveModel('保存成功', '', 'success');
                            }, 500);
                        }
                        messagePublishService.publish(`${$scope.parentStatus.mediaName}VersionInit`);
                        beforeonload.refresh($scope);
                        storageListenerService.addListenerToWeibo('save');
                        defer.resolve(data.METADATAID);
                    }, function(data) {
                        defer.reject(data);
                    });
                });
            }).error(function(msg) {
                editingCenterService.checkSaveError($scope.wbheadlinesForm, $element, $scope);
                defer.reject();
            });
            return defer.promise;
        };

        /**
         * [picCallbackData description] 点击获取封面图的回调
         * @return {[type]} [description]
         */
        $scope.picCallbackData = function () {
            if ($scope.list.COVER) {
                modalDialog.alertType('封面图已填充满', '', 'warning', false);
                return;
            }
            var picresize = $scope.parentStatus.topAttachFilePicSize;
            return function (fileName) {
                editPictureService.newCropperApp(fileName, picresize).then(
                    function (src) {
                        $scope.list.COVER = src.imgName || src.APPFILE;
                        $scope.parentData.IMAGEDESC = src.imgName || src.APPDESC;
                        $scope.parentData.imgSrc = src.imgSrc || src.PERPICURL;
                    },
                    function () { }
                );
            };
        };
    }
]);
